import React from 'react';

import { flagStyles } from '../settings';

const SvgFJ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1656px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgFJ;
